import { Box, Input as ChakraInput, Text } from '@chakra-ui/react'
import { forwardRef } from 'react'

export const InputInnovationDoubleDate = forwardRef(
  ({ children, ...rest }, ref) => {
    return (
      <Box
        position="relative"
        h="37px"
        display="flex"
        alignItems="center"
        cursor="pointer"
        bgColor="#fff"
        px={2}
        border="1px solid #378BBF"
        borderRadius="4px"
        {...rest}
      >
        {children}
      </Box>
    )
  },
)
